import { render, staticRenderFns } from "./BindUserInfoTip.vue?vue&type=template&id=8b702c24&scoped=true&"
import script from "./BindUserInfoTip.vue?vue&type=script&lang=js&"
export * from "./BindUserInfoTip.vue?vue&type=script&lang=js&"
import style0 from "./BindUserInfoTip.vue?vue&type=style&index=0&id=8b702c24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b702c24",
  null
  
)

export default component.exports